import React from 'react';
import { HelpCircleIcon, UsersIcon, DollarSignIcon, VideoIcon, SearchIcon } from 'lucide-react';
import { Reveal, Eyebrow } from './Section';
const pains = [{
  icon: HelpCircleIcon,
  text: 'Querés empezar en UGC, pero no sabés cuál debería ser tu primer paso.'
}, {
  icon: UsersIcon,
  text: 'Pensás que necesitás miles de seguidores para que una marca te contrate.'
}, {
  icon: DollarSignIcon,
  text: 'Querés trabajar con marcas y cobrar en dólares, pero no tenés experiencia, clientes ni testimonios.'
}, {
  icon: VideoIcon,
  text: 'No sabés qué videos grabar para construir un portfolio que se vea profesional.'
}, {
  icon: SearchIcon,
  text: 'Abrís Instagram buscando marcas, pero terminás sin saber a cuáles contactar ni qué decirles.'
}];
export function Problem() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-140" data-mp="1it539foygeok">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-141" data-mp="1np3lsmnlr2h2">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-142" data-mp="1nrznmm2kmbas">
          <Eyebrow data-id="element-143" data-mp="t8m3tl2yrqil">¿Te suena familiar?</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-144" data-mp="oau6gbjjvc70">
            Sabés que el UGC es tu oportunidad, pero algo te frena
          </h2>
          <p className="mt-4 text-ink/70" data-id="element-145" data-mp="128923y0ecg7f">
            Si te identificás con alguna de estas situaciones, este ebook fue hecho para vos.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-146" data-mp="9mh9bb8q7nax">
          {pains.map((p, i) => <Reveal key={p.text} delay={i * 0.06} data-id="element-147" data-mp="5i9lrhe08dea" data-mpi={i}>
              <div className="flex h-full items-start gap-4 rounded-2xl border border-sand bg-white p-6 shadow-card transition-transform duration-300 hover:-translate-y-1" data-id="element-148" data-mp="jc0y0xj4ebdp">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-rose-soft text-coral-dark" data-id="element-149" data-mp="3n0kpacvtelje">
                  <p.icon className="h-5 w-5" data-id="element-150" data-mp="3i0py0884ntxt" />
                </span>
                <p className="text-sm leading-relaxed text-ink/80" data-id="element-151" data-mp="1lyw8emuwkbc9">{p.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}